import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {DetailComponent} from './detail/detail.component';
import {OverviewComponent} from './overview/overview.component';

const routes: Routes = [
    { path: 'supplier/overview', component: OverviewComponent},
    { path: 'supplier/detail/:method', component: DetailComponent},
    { path: 'supplier/detail/:method/:supplierId/:costcenterId', component: DetailComponent}
    ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SupplierRoutingModule { }
